export default {
  profileInfoHead: {
    borderBottom: '1px solid #eee',
    margin: '-22px -22px 0'
  }
}
